import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface EmailObfuscatedProps {
  userB64: string;
  domainB64: string;
  className?: string;
}

export function EmailObfuscated({ userB64, domainB64, className }: EmailObfuscatedProps) {
  const { t } = useTranslation('common');
  const [email, setEmail] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setEmail(`${atob(userB64)}@...`);
  }, [userB64, domainB64]);

  const handleClick = async () => {
    let email: string;
    try {
      if (!userB64 || !domainB64) return;
      email = `${atob(userB64)}@${atob(domainB64)}`;
      setEmail(email);
      await navigator.clipboard.writeText(email);
    } catch (err) {
      console.error(err);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 text-left transition-colors hover:text-foreground ${className ?? ''}`}
      title={t('copy_email')}
      type="button"
    >
      <span>{email}</span>
      {copied ? (
        <Check className="h-3 w-3 shrink-0 text-green-500" />
      ) : (
        <Copy className="h-3 w-3 shrink-0 opacity-50" />
      )}
    </button>
  );
}
